document.addEventListener('DOMContentLoaded', () => {
    const CART_ID = "425581b8-f200-4f88-a701-f6897af78dd1";
  
    const waitForRecos = () => {
      if (window.recos && typeof recos.reco === 'function') {
        initDrawerObserver();
      } else {
        setTimeout(waitForRecos, 100);
      }
    };
    waitForRecos();
  
    function initDrawerObserver() {
      const drawer = document.querySelector('.cart-drawer');
      if (!drawer) return console.warn('Potions – drawer introuvable');
    
      const obs = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.attributeName === 'class') {
            const isOpen = drawer.classList.contains('is-opened');
            if (isOpen) {
              fetchAndInject(); // Appelé à CHAQUE ouverture
            }
          }
        }
      });
    
      obs.observe(drawer, { attributes: true });
    }
  
    function fetchAndInject() {
      recos.reco(CART_ID)
        .then(({ products }) => observeSliderAndUpdate(products))
        .catch(err => console.error('Potions reco failed:', err));

    }
  
    function observeSliderAndUpdate(products) {
      const drawer = document.querySelector('.cart-drawer');
      const slider = drawer.querySelector('.slider-grid-track');
      const cards = slider?.querySelectorAll('.vertical-product-card') || [];
    
      if (cards.length) {
        updateCards(cards, products);
        return;
      }
    
      const obs = new MutationObserver(async (_, obs) => {
        const slider = drawer.querySelector('.slider-grid-track');
        const cards  = slider?.querySelectorAll('.vertical-product-card') || [];
        if (cards.length) {
          obs.disconnect();
          await updateCards(cards, products);
        }
      });
      obs.observe(drawer, { childList: true, subtree: true });
    }
    
  
    async function updateCards(cards, products) {
      const currentLang = document.documentElement.lang || 'fr';

      cards.forEach((card, i) => {
        const p = products[i];
        if (!p) return;
  
        const img      = card.querySelector('.vertical-product-card__image');
        const title    = card.querySelector('.vertical-product-card__title');
        const price    = card.querySelector('.vertical-product-card__price-item');
        const oldPrice = card.querySelector('.vertical-product-card__old-price-item');
        const link     = card.querySelector('.vertical-product-card__link');
        const promo    = card.querySelector('#promo-span-vertical');

        if (img) {
          img.src = p.img_link;
          img.removeAttribute('srcset');
          img.removeAttribute('data-srcset');
          
          setTimeout(() => {
            if (img.src !== p.img_link) {
              img.src = p.img_link;
              img.removeAttribute('srcset');
              img.removeAttribute('data-srcset');
            }
          }, 500);
        } else {
          console.warn('Potions – image introuvable');
          setTimeout(() => {
            if (img) {
              img.src = p.img_link;
              img.removeAttribute('srcset');
              img.removeAttribute('data-srcset');
            }
          }, 500);
        }
        if (oldPrice) { oldPrice.style.display = 'none'; }
        if (title) { 
          title.textContent = p.title;
        }
        if (price)    { price.textContent = `${p.price} €`; }
        if (link && p.colors?.[0]?.link) { link.href = p.colors[0].link; }
        if (promo)    { promo.style.display = 'none'; }
      });
    }
  });
  